import { Component, OnInit, Input, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { CoursewareQuizQuestionEditModel } from 'src/model/Test/CoursewareQuizQuestionEditModel';
import { QuizAnswer } from './quiz-answer.component';

@Component({
  selector: 'app-quiz-question',
  templateUrl: './quiz-question.component.html',
  styleUrls: ['./quiz-question.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class QuizQuestion implements OnInit {
  @Input() item: CoursewareQuizQuestionEditModel;
  @Input() itemNum: number;
  @ViewChildren(QuizAnswer) theAnswers: QueryList<QuizAnswer>

  constructor() { }

  ngOnInit() {
  }

  clearAnswers() {
    this.theAnswers.forEach(answerInstance => answerInstance.clearAnswer());
  }

}
